import isNil from './is-nil';
import isArraylike from './is-array-like';
export default function size(o) {
    if (isNil(o)) {
        return 0;
    }
    if (isArraylike(o)) {
        return o.length;
    }
    return Object.keys(o).length;
}
//# sourceMappingURL=size.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/size.js
// module id = 520
// module chunks = 3